/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Open, 1 = Closed, 2 = Shipped, 3 = Received
 */
export enum PackageStatus {
    Open = 0,
    Closed = 1,
    Shipped = 2,
    Received = 3
}

